<template>
  <section class="partners-section">
    <h2 class="section-title">
      <span class="highlight">全球</span><span class="sub">合作伙伴</span>
    </h2>
    <div class="partner-grid">
      <div
        v-for="partner in partners"
        :key="partner.id"
        class="partner-item"
      >
        <img
          :src="partner.image"
          :alt="`partner${partner.id}`"
          class="partner-logo"
          :style="partner.logoStyle"
          @load="handleLogoLoad($event, partner)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { PARTNERS_LIST } from "../config";

export default {
  data() {
    return {
      partners: PARTNERS_LIST.map((partner) => ({
        ...partner,
        logoStyle: null,
      })),
    };
  },
  methods: {
    handleLogoLoad(event, partner) {
      const img = event.target;
      if (!img.naturalWidth || !img.naturalHeight) return;

      this.$set(partner, "logoStyle", {
        width: `${img.naturalWidth * 0.5}px`,
        height: `${img.naturalHeight * 0.5}px`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.partners-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 0 0 40px;
  font-size: 40px;
  font-weight: normal;
  line-height: 1.3;
  text-align: center;

  .highlight {
    color: #7338ff;
  }

  .sub {
    color: rgba(255, 255, 255, 0.75);
  }
}

.partner-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 39.2px 16px;
}

.partner-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

.partner-logo {
  display: block;
  object-fit: contain;
}
</style>
